import { getRequest } from 'config/Axios/baseConfig';
import { AlljobsInterface, JobDataInterface } from 'screens/JobTagsScreen/jobScreenTypes';

export const getAllJobsServices = {
  getAllJobs: (): Promise<AlljobsInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<AlljobsInterface>('pps/get_all_non_completed_jobs');
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  },

  getJobData: (job_id: string): Promise<JobDataInterface> => {
    return new Promise(async (resolve, reject) => {
      try {
        const response = await getRequest<JobDataInterface>(`pps/get_job_info/${job_id}`);
        resolve(response.data);
      } catch (error) {
        reject(error);
      }
    });
  }
};
